import { CheckCircle, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';

// A finished Job Simulation step: best score stays, the learner can retake to improve it
export const CompletedStep = ({ score, lastScore, attempts, disabled, onRetake, testId }) => (
    <div className="space-y-3" data-testid={`${testId}-completed`}>
        <div className="flex items-center gap-2 text-emerald-600">
            <CheckCircle className="h-5 w-5" />
            <span data-testid={`${testId}-best-score`}>Completed - Best score: {score ?? 0}%</span>
        </div>
        {attempts > 1 && lastScore != null && (
            <p className="text-xs text-muted-foreground" data-testid={`${testId}-attempts`}>
                {attempts} attempts · latest {lastScore}%
            </p>
        )}
        <Button variant="outline" size="sm" className="w-full gap-2" disabled={disabled} onClick={onRetake} data-testid={`${testId}-retake-btn`}>
            <RotateCcw className="h-4 w-4" /> Retake to improve
        </Button>
    </div>
);
